/* Stealth gallery — lightbox and staggered reveal.
   Progressive enhancement only: with this file blocked the grid is still a
   complete, readable, fully visible gallery of links-free figures. Nothing
   here is required to see the photographs. */
(function () {
  if (window.__stealthGalleryInit) return;
  window.__stealthGalleryInit = true;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var cells = [].slice.call(root.querySelectorAll('.gal-cell'));
    if (!cells.length) return;

    /* ---------- staggered entrance ----------
       Index within its own row band rather than the whole grid, so late
       photographs do not inherit a two second delay. */
    if (!reduce && 'IntersectionObserver' in window) {
      /* Declare the enhancement before anything is hidden: the stylesheet
         only dims cells once this class exists, so a failure to load this
         file leaves every photograph visible rather than blanking the page. */
      root.classList.add('js-stagger');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var i = cells.indexOf(e.target) % 4;
            e.target.style.transitionDelay = i * 70 + 'ms';
            e.target.classList.add('is-lit');
            io.unobserve(e.target);
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
      );
      cells.forEach(function (c) {
        io.observe(c);
      });
    } else {
      cells.forEach(function (c) {
        c.classList.add('is-lit');
      });
    }

    /* ---------- lightbox ---------- */
    var box = root.querySelector('.gal-box');
    if (!box) return;
    var boxImg = box.querySelector('.gal-box__img');
    var boxName = box.querySelector('.gal-box__name');
    var boxMeta = box.querySelector('.gal-box__meta');
    var boxCount = box.querySelector('.gal-box__count');
    var current = -1;
    var lastFocus = null;

    function show(i) {
      if (i < 0) i = cells.length - 1;
      if (i >= cells.length) i = 0;
      current = i;
      var cell = cells[i];
      var img = cell.querySelector('img');
      if (!img) return;

      var full = cell.getAttribute('data-full') || img.currentSrc || img.src;
      boxImg.src = full;
      boxImg.alt = img.alt || '';

      var name = cell.getAttribute('data-name') || '';
      var meta = cell.getAttribute('data-meta') || '';
      boxName.textContent = name;
      boxName.hidden = !name;
      boxMeta.textContent = meta;
      boxMeta.hidden = !meta;
      boxCount.textContent = i + 1 + ' / ' + cells.length;

      /* Warm the neighbours so arrowing through feels instant. */
      [i - 1, i + 1].forEach(function (n) {
        var c = cells[(n + cells.length) % cells.length];
        var u = c && c.getAttribute('data-full');
        if (u) {
          var p = new Image();
          p.src = u;
        }
      });
    }

    function open(i) {
      lastFocus = document.activeElement;
      show(i);
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      /* rAF so the transition has a frame to start from */
      requestAnimationFrame(function () {
        box.classList.add('is-open');
      });
      var close = box.querySelector('.gal-box__close');
      if (close) close.focus();
    }

    function close() {
      box.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      var done = function () {
        box.hidden = true;
        boxImg.removeAttribute('src');
      };
      if (reduce) done();
      else setTimeout(done, 200);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    cells.forEach(function (cell, i) {
      var btn = cell.querySelector('.gal-cell__open');
      if (btn) {
        btn.addEventListener('click', function () {
          open(i);
        });
      }
    });

    box.addEventListener('click', function (e) {
      if (
        e.target === box ||
        e.target.classList.contains('gal-box__stage') ||
        e.target.closest('.gal-box__close')
      ) {
        close();
      }
      if (e.target.closest('.gal-box__prev')) show(current - 1);
      if (e.target.closest('.gal-box__next')) show(current + 1);
    });

    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
      else if (e.key === 'Tab') {
        /* Keep focus inside the dialog while it is open. */
        var f = [].slice
          .call(box.querySelectorAll('button'))
          .filter(function (el) {
            return el.offsetParent !== null;
          });
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  function boot() {
    document.querySelectorAll('.stealth-gal').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
